const STORAGE_KEY = 'signInReturnPath'

// Session-scoped so it survives the SSO round trip but not a new tab.
export function useSignInReturnPath() {
    // Called before bouncing a signed-out visitor (e.g. from a notification email link) to sign-in.
    function remember(path) {
        if (path && path !== '/') sessionStorage.setItem(STORAGE_KEY, path)
    }

    // One-shot; only same-origin paths are honored so a stored value can't redirect off-site.
    function take(fallback) {
        const path = sessionStorage.getItem(STORAGE_KEY)
        sessionStorage.removeItem(STORAGE_KEY)
        return path?.startsWith('/') && !path.startsWith('//') ? path : fallback
    }

    return { remember, take }
}
